import { useEffect } from "react";

import { Link } from "react-router-dom";

import styles from "../styles/brands.module.scss";

import { Title } from "../shared/components/Title";
import { Empty } from "../shared/components/Empty";
import { Button } from "../shared/components/Button";
import { Drawer } from "../shared/components/Drawer";
import { Icon } from "../shared/components/core/Icon";
import { useState } from "react";
import { Input } from "../shared/components/Input";

import { EnvironmentsAPI } from "../providers/EnvironmentsAPI";
import { AssetsAPI } from "../providers/AssetsAPI";
import { UserStorage } from "../shared/tools/UserStorage";
import { Loading } from "../shared/components/Loading";
import { BrandCard } from "../shared/containers/Brands/BrandCard";

export default function Brands() {
  const [visible, setVisible] = useState(false);
  const [loading, setLoading] = useState(false);
  const [loadingSubmit, setLoadingSubmit] = useState(true);
  const [brand, setBrand] = useState({});
  const [brands, setBrands] = useState([]);
  const [payload, setPayload] = useState({});
  const [helpdeskContact, setHelpDeskContact] = useState({});

  useEffect(() => {
    const loadData = async () => {
      let { environment_id, user_type } = UserStorage.getLoggedUser();
      if (user_type === "BRAND") {
        const holdingResponse = await EnvironmentsAPI.getById(environment_id);
        environment_id = holdingResponse.getData({}).environment_id;
      }

      const response = await EnvironmentsAPI.getUnits(String(environment_id));
      const brands = response.getData({}).brands;

      setBrands(brands);
      setLoadingSubmit(false);
    };
    loadData();
  }, []);

  const handleSubmit = () => {
    setLoading(true);

    setTimeout(async () => {
      const { environment_id } = UserStorage.getLoggedUser();
      const response = await EnvironmentsAPI.postEnvironment(
        environment_id,
        payload
      );

      const createdBrand = response.getData({});
      if (createdBrand.id) {
        await EnvironmentsAPI.putConfigurationsByAlias(
          createdBrand.id,
          "helpdesk_contact",
          helpdeskContact
        );
      }

      setPayload({});
      setBrand({});
      setHelpDeskContact({});

      setBrands([...brands, createdBrand]);
      setVisible(false);
      setLoading(false);
    }, [2000]);
  };

  const handleSetImage = async (e) => {
    const file = e.target.files[0];

    if (file) {
      const maxFileSize = 5;
      const fileSize = file.size / 1024 / 1024;
      const fileType = file.type;

      if (fileSize > maxFileSize) {
        alert({ text: `Escolha um arquivo com no máximo ${maxFileSize}MB` });
        return false;
      }

      const pattern = /image-*/;

      if (!fileType.match(pattern)) {
        alert({ text: "Arquivo inválido." });

        return false;
      }

      let reader = new FileReader();
      reader.onload = async (readerEvent) => {
        setBrand({ ...brand, imageURI: readerEvent.target.result });
        const response = await AssetsAPI.PostAssets({
          mime_type: fileType,
          file: readerEvent.target.result.split("base64,")[1],
        });
        delete payload.avatarUrl;
        setPayload(Object.assign({ avatarUrl: response.getData({}) }, payload));
      };

      reader.readAsDataURL(file);
    }
  };

  return (
    <div className={styles.brandsContainer}>
      <Title
        title="Marcas"
        // backTo={{ url: "/configuracoes", name: "Configurações" }}
      >
        {!!(brands || []).length && (
          <Button design="primary" onClick={() => setVisible(true)} add>
            Adicionar marca
          </Button>
        )}
      </Title>
      {loadingSubmit && (
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            position: "absolute",
            minWidth: "-webkit-fill-available",
            minHeight: "-webkit-fill-available",
          }}
        >
          <Loading />
        </div>
      )}

      {(brands || []).length <= 0 && !loadingSubmit ? (
        <Empty>
          <Icon name="store" size="4x" />
          <p>Você ainda não possui marcas</p>
          <span>
            Através desta ferramenta, você pode registrar suas marcas.
          </span>
          <Button design="primary" onClick={() => setVisible(true)}>
            Adicionar marca
          </Button>
        </Empty>
      ) : (
        <div className={styles.brands}>
          {(brands || []).map((brand, index) => {
            return <BrandCard brand={brand} key={index} />;
          })}
        </div>
      )}

      <Drawer
        visible={visible}
        onClose={() => setVisible(false)}
        title="Adicionar marca"
        footer={
          <Button
            design="primary"
            className="w-100"
            disabled={!payload.name}
            loading={loading}
            onClick={handleSubmit}
          >
            Salvar
          </Button>
        }
      >
        <div className="d-flex align-center">
          <label htmlFor="brand-picture" className={styles.customFileInput}>
            <span className={styles.plus}>
              <Icon name="plus" color="#fff" />
            </span>
            <input
              type="file"
              id="brand-picture"
              accept="image/*"
              onChange={(e) => handleSetImage(e)}
            />
            {brand.imageURI ? (
              <img src={brand.imageURI} alt={brand.name} />
            ) : (
              <Icon name="image-polaroid" size="2x" light />
            )}
          </label>
        </div>

        <Input
          design="two"
          className="mb-20"
          floatLabel="Nome da marca"
          onChange={(e) => setPayload({ ...payload, name: e.target.value })}
        />
        <Input
          design="two"
          className="mb-20"
          floatLabel="E-mail"
          onChange={(e) =>
            setHelpDeskContact({ ...helpdeskContact, email: e.target.value })
          }
        />
        <Input
          design="two"
          className="mb-20"
          floatLabel="Telefone"
          type="tel"
          mask="(99) 99999-9999"
          onChange={(e) =>
            setHelpDeskContact({ ...helpdeskContact, phone: e.target.value })
          }
        />
        <Input
          design="two"
          className="mb-20"
          floatLabel="Whatsapp"
          type="tel"
          mask="(99) 99999-9999"
          onChange={(e) =>
            setHelpDeskContact({
              ...helpdeskContact,
              whatsapp_phone: e.target.value,
            })
          }
        />
      </Drawer>
    </div>
  );
}
